import { Badge, Tooltip } from '@sequencehq/core-components'
import { format, parseISO } from '@sequencehq/utils/dates'
import { FC } from 'react'
import type { XeroMonthSync } from './deriveMonthSyncState'
import {
  XERO_SYNC_STATE_LABEL,
  XERO_SYNC_STATE_SENTIMENT,
  XERO_SYNC_TEST_IDS
} from './xeroSync.constants'

/**
 * A month's Xero sync state as a badge — green synced, indigo syncing, amber
 * changed, grey not synced, red failed. Once a month has posted, the badge
 * carries a tooltip with when it last synced.
 */
export const XeroSyncBadge: FC<{ sync: XeroMonthSync }> = ({ sync }) => {
  const badge = (
    <Badge
      sentiment={XERO_SYNC_STATE_SENTIMENT[sync.state]}
      data-testid={`${XERO_SYNC_TEST_IDS.badge}.${sync.monthKey}`}
    >
      {XERO_SYNC_STATE_LABEL[sync.state]}
    </Badge>
  )

  if (!sync.lastSyncedAt) {
    return badge
  }

  return (
    <Tooltip
      label={`Last pushed ${format(parseISO(sync.lastSyncedAt), 'd MMM yyyy, HH:mm')}`}
    >
      {badge}
    </Tooltip>
  )
}
